import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { PATIENT_GENDERS, PatientGender } from '../../util/PatientData';

/**
 * Fecha de nacimiento y género del paciente. Es el mismo bloque en el alta y en la ventana de
 * editar datos. Los dos son obligatorios y arrancan en blanco para que el doctor los capture.
 * Sus campos se registran en el formulario de la pantalla que lo usa, así que cuentan para
 * habilitar el botón de guardar.
 */
@Component({
  selector: 'app-patient-personal-fields',
  templateUrl: './patient-personal-fields.component.html',
  styleUrls: ['./patient-personal-fields.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class PatientPersonalFieldsComponent
{
  @Input() public birthday: Date | null;
  @Output() public birthdayChange: EventEmitter<Date | null> = new EventEmitter<Date | null>();

  @Input() public gender: PatientGender | null;
  @Output() public genderChange: EventEmitter<PatientGender | null> = new EventEmitter<PatientGender | null>();

  public readonly today: Date = new Date();
  public readonly genders = PATIENT_GENDERS;

  public onBirthdayChange(value: Date | null): void
  {
    // Sin hora, para que la edad no cambie según la zona horaria
    const birthday = value ? new Date(value) : null;
    birthday?.setHours(0, 0, 0, 0);

    this.birthday = birthday;
    this.birthdayChange.emit(birthday);
  }

  public onGenderChange(value: PatientGender): void
  {
    this.gender = value;
    this.genderChange.emit(value);
  }
}
